<script lang="ts">
	import Labelled from "@components/form/Labelled.svelte";
	import Textarea from "@components/form/Textarea.svelte";
	import type { ComponentProps, Snippet } from "svelte";
	import type { ClassValue, HTMLLabelAttributes } from "svelte/elements";

	const {
		wrapperClass,
		label,
		children,
		...rest
	}: ComponentProps<typeof Textarea> & { wrapperClass?: ClassValue; children: Snippet; label?: HTMLLabelAttributes } =
		$props();

	const id = $derived(`${rest.id ?? rest.name ?? ""}-${crypto.randomUUID()}`);
</script>

<Labelled {wrapperClass} required={rest.required} label={{ ...label, for: id }}>
	{@render children()}
	{#snippet content()}
		<Textarea {...rest} {id} />
	{/snippet}
</Labelled>
